// extracted by mini-css-extract-plugin
export var button = "content-type-icon-module--button--debac";
export var corner = "content-type-icon-module--corner--1aa27";
export var icon = "content-type-icon-module--icon--4cccd";
export var root = "content-type-icon-module--root--25a0d";
export var sizeMedium = "content-type-icon-module--sizeMedium--82647";
export var sizeSmall = "content-type-icon-module--sizeSmall--43573";
export var title = "content-type-icon-module--title--1a0d4";
export var typeContentfulArticle = "content-type-icon-module--typeContentfulArticle--c61b5";
export var typeContentfulMeetup = "content-type-icon-module--typeContentfulMeetup--4ec05";
export var typeContentfulMultimedia = "content-type-icon-module--typeContentfulMultimedia--218d7";